import { render, staticRenderFns } from "./items-type-other.vue?vue&type=template&id=383f6cbb&scoped=true"
import script from "./items-type-other.vue?vue&type=script&lang=js"
export * from "./items-type-other.vue?vue&type=script&lang=js"
import style0 from "./items-type-other.vue?vue&type=style&index=0&id=383f6cbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f6cbb",
  null
  
)

export default component.exports